import React from 'react';
import PropTypes from 'prop-types';

export const HCPSignupHeader = ({ title, subtitle }) => (
  <React.Fragment>
    <div className="hcp-signup-title">{title}</div>
    {!!subtitle && <div className="hcp-signup-subtitle">{subtitle}</div>}
  </React.Fragment>
);

HCPSignupHeader.propTypes = {
  title: PropTypes.any.isRequired,
  subtitle: PropTypes.any,
};
